import React, { useState } from 'react';
import { Form, Button, Image } from 'react-bootstrap';
import MediaLibrary from '../MediaLibrary';

const CardComponentForm = ({ formValues, setFormValues }) => {
    const [showLibrary, setShowLibrary] = useState(false);

    const handleImageSelect = (url) => {
        setFormValues({ ...formValues, imageUrl: url });
        setShowLibrary(false); // Close the media library after image selection
    };

    const handleRemoveImage = () => {
        setFormValues({ ...formValues, imageUrl: '' });
    };

    return (
        <>
            <div className="carousel-wrap">
                <div className="row">
                    <div className="col-md-3">
                        <div className="media-img-wrap">
                            {formValues.imageUrl ? (
                                <Image
                                    src={formValues.imageUrl}
                                    alt="Selected Image"
                                    thumbnail
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        backgroundColor: '#f0f0f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1px solid #ddd',
                                        borderRadius: '5px',
                                    }}
                                >
                                    No Image Selected
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-9 single-img-wrap-e">
                        <MediaLibrary
                            onSelectImage={handleImageSelect}
                            show={showLibrary}
                            setShow={setShowLibrary}
                        />
                        {formValues.imageUrl && (
                            <Button variant="danger" className="mt-2" onClick={handleRemoveImage}>
                                Remove Image
                            </Button>
                        )}
                    </div>
                </div>
            </div>
            
            <Form.Group controlId="formCardTitle" className="mb-3">
                <Form.Label>Card Title</Form.Label>
                <Form.Control
                    type="text"
                    name="title"
                    value={formValues.title || ''}
                    onChange={(e) => setFormValues({ ...formValues, title: e.target.value })}
                />
            </Form.Group>

            



            <Form.Group controlId="formCardBodyText" className="mb-3">
                <Form.Label>Body Text</Form.Label>
                <Form.Control
                    type="text"
                    name="bodyText"
                    value={formValues.bodyText || ''}
                    onChange={(e) => setFormValues({ ...formValues, bodyText: e.target.value })}
                />
            </Form.Group>
        </>
    );
};

export default CardComponentForm;
